import { Sport } from '@/feature/event-details-sbk/types';

export const getSportKey = (sport: Sport) => {
    return sport?.name.toLowerCase().replace(/ /g, '_');
};
